document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.el-article-leading-section__social-links');
  if (!container) {
    return;
  }

  const copySelector = 'button.el-article-leading-section__social-link[data-action="copy-link"]';

  function initTippy(el) {
    if (el._tippy) {
      el._tippy.destroy();
    }
    if (window.tippy) {
      tippy(el, {
        trigger: 'manual',
        placement: 'top',
        hideOnClick: false,
        animation: 'shift-away',
        duration: [150, 150],
        arrow: true,
        theme: el.dataset.tippyTheme || 'share',
      });
    }
  }

  async function copyToClipboard(text) {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (_) {
      return false;
    }
  }

  function showTooltip(el, message) {
    if (!el._tippy && window.tippy) {
      initTippy(el);
    }
    const inst = el._tippy;
    if (!inst) {
      return;
    }
    inst.setContent(message);
    inst.show();
    clearTimeout(el._tippyHideTimer);
    el._tippyHideTimer = setTimeout(() => inst.hide(), 2500);
  }

  container.querySelectorAll(copySelector).forEach((el) => {
    initTippy(el);

    const handle = async (e) => {
      e.preventDefault();
      const url = el.getAttribute('data-copy-text') || location.href;
      const ok = await copyToClipboard(url);
      showTooltip(el, ok ? el.getAttribute('data-tippy-content') || 'Link copied' : 'Copy failed');
    };

    el.addEventListener('click', handle);
    el.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        handle(e);
      }
    });
  });
});
